<template>
  <div>
    <LogoImg/>
    <NavBar/>
    <NavMobile/>
    <GradientMap/>
    <SectionTitle :sectionTitle="contact_us"
                  :padding="'section-title--padding-top'"/>
    <ContactComponent/>
    <MapComponent/>
    <Footer/>
  </div>
</template>

<script>
import LogoImg from './LogoImg.vue'
import NavBar from './NavBar.vue'
import GradientMap from './GradientMap.vue'
import SectionTitle from './SectionTitle.vue'
import ContactComponent from './ContactComponent.vue'
import MapComponent from './MapComponent.vue'
import NavMobile from './NavMobile.vue'
import Footer from './Footer.vue'


export default {
  name: 'PageContact',
  components: {
    LogoImg,
    NavBar,
    GradientMap,
    SectionTitle,
    Footer,
    NavMobile,
    ContactComponent,
    MapComponent
  },
  data () {
    return {
      contact_us: {
        title: 'NAWIĄŻ Z NAMI WSPÓŁPRACĘ LUB ZADAJ NAM PYTANIE'
      }
    }
  }
}
</script>
